import { TitleStyles } from './Title.styles';

export const Title = () => {
  return (
    <TitleStyles className="success-payment-page-title">
      Devmode purchase
      <br /> was successful!
    </TitleStyles>
  );
};
